<template>
<div class="pa-5">
  <v-container fill-height>
    <v-layout align-center justify-center fill-height row wrap>
      <v-flex sm6 md5>
        <v-form v-model="valid">
          <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
          <v-text-field type="password" v-model="password" :rules="passwordRules" label="Password" required></v-text-field>
          <v-btn type="submit" @click.prevent="login" :disabled="!valid" color="info">Login</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import * as firebase from "../firebase.js";
export default {
  data() {
    return {
      valid:false,
      password:'',
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => v.length>3 || 'Password must be longer than 3 characters'
      ]
    }
  },
  methods:{
    login(){
      var self=this;
      //console.log(self)
      firebase.auth.signInWithEmailAndPassword(this.email,this.password).then(user=>{
        this.$store.dispatch({
          type: 'setAdmin',
          user,
         })
          self.$router.replace('/admin')
        },
        err=>{
          alert(err.message)
        }
      )
    }
  }
}
</script>

<style>
</style>
